import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.style.width = this.getWidth() + "px"
        this.element.addEventListener('input', () => {
            const parentWidth = this.element.parentElement.parentElement.parentElement.clientWidth - 100;
            const newWidth = this.getWidth();
            this.element.style.width = (newWidth > parentWidth ? parentWidth : newWidth) + 'px';
        })
    }

    getWidth() {
        let min_width = 300;
        let tmp = document.createElement('div');
        tmp.textContent = this.element.value + 'wwwwwwww';
        tmp.style.visibility = 'hidden';
        tmp.style.position = 'absolute';
        tmp.style.whiteSpace = 'pre';
        tmp.style.font = getComputedStyle(this.element).font;
        document.body.appendChild(tmp);
        let width = Math.max(tmp.getBoundingClientRect().width, min_width);
        document.body.removeChild(tmp);
        return width;
    }
}
